<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-09-13 15:03:49
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-11-08 11:36:10
 * @FilePath: \vue-hepha-order\src\views\financial\OverdueList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @cellDblClick="cellDblClick"
        >
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'finance_remark'" class="remark">
                    <a-tooltip :content="props.record.finance_remark">
                        <div class="remark_content" v-if="props.record.remarkIsText">{{ props.record.finance_remark }}</div>
                    </a-tooltip>
                    
                    <a-input v-if="!props.record.remarkIsText" :style="{width:'230px'}" v-model="props.record.finance_remark" />
                    <icon-check v-if="!props.record.remarkIsText" @click="saveComment(props.record)" :style="{display:'inline-block',marginLeft:'5px',color:'green',cursor:'pointer',fontWeight:'blod'}"/>
                    <icon-close v-if="!props.record.remarkIsText" @click="cancelSaveComment(props.record)" :style="{display:'inline-block',marginLeft:'10px',color:'red',cursor:'pointer',fontWeight:'blod'}"/>
                </div>
            </template>

            <template v-slot:searchFilter="{ props }">
                <div class="searchFilter">
                    <a-space direction="vertical">
                    <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                    <div class="searchFilter-footer">
                        <a-button  style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                        <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                    </div>
                    </a-space>
                </div>
            </template>
        </Table>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { FinancialApi } from '@/api/FinancialApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import OverdueList from './OverdueList.vue';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { IconSearch } from '@arco-design/web-vue/es/icon';

    const localeStore = useLocale()
    const { t } = useI18n()

    const table = ref({
        datas:[],
        columns:[
            {
                // title: '序号',
                title:'#',
                dataIndex: 'no',
                key:'no',
                width:'60',
            }, 
            {
                // title: '订单来源',
                title:t('financial.customer'),
                dataIndex: 'customer',
                key:'customer',
                width:'220',
                filterable: {
                    filter: (value, record) => record.customer.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '订单编号',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'170',
                filterable: {
                    filter: (value, record) => record.order_name.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '发票号',
                title:t('financial.invoiceNumber'),
                dataIndex: 'invoice_number',
                key:'invoice_number',
                width:'130',
                filterable: {
                    filter: (value, record) => record.invoice_number.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            }, 
            // {
            //     // title: '状态',
            //     title:t('financial.level'),
            //     dataIndex: 'level',
            //     key:'level',
            //     width:'100',
            // },
            {
                // title: '逾期时长',
                title:t('financial.overdueDays'),
                dataIndex: 'overdue_days',
                key:'overdue_days',
                width:'140',
                filterable: {
                    filters: [ 
                        {
                            text: '> 60',
                            value: 60,
                        },
                        {
                            text: '> 120',
                            value: 120,
                        },
                        {
                            text: '> 180',
                            value: 180,
                        }
                    ],
                    filter: (value, record) => record.overdue_days > value,
                }
            },
            {
                // title: '订单金额',
                title:t('order.payAmount'),
                dataIndex: 'pay_amount',
                key:'pay_amount',
                width:'130',
            },
            {
                // title: '备注',
                title:t('stock.remark'),
                dataIndex: 'finance_remark',
                key:'finance_remark',
                width:'280',
                ellipsis:true,
                tooltip:true,
                slotName:'slot',
                filterable: {
                    filter: (value, record) => record.finance_remark.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            // {
            //     // title: '销售',
            //     title:t('financial.salesName'),
            //     dataIndex: 'sales_name',
            //     key:'sales_name',
            //     width:'120',
            // },
            {
                // title: '发票时间',
                title:t('financial.invoiceTimestamp'),
                dataIndex: 'invoice_timestamp',
                key:'invoice_timestamp',
                width:'130',
                ellipsis:true,
                tooltip:true,
            },
            // {
            //     title: t('base.operate'),
            //     dataIndex: 'Optional',
            //     key:'Optional',
            //     slotName:'optional',
            //     width: '180',
            //     align:'center',
            //     fixed:'right'
            // }
        ],
        configs:{
            scroll:{
                x:1000,
                y:440,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    // 双击单元格
    const cellDblClick = (row,column)=>{
        // console.log(column,'col')
        if(column.key == 'finance_remark'){
            row.remarkIsText = false
        }
    }

    const cancelSaveComment = (row)=>{
        row.remarkIsText = true
        getOverdueList()
    }

    // 保存备注
    const saveComment = async (row)=>{
        let param = {
            instruction:row.finance_remark,
        }
        let res = await FinancialApi.getInstance().saveRemarkOverdueList(param,row.invoice_id)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            row.remarkIsText = true
            getOverdueList()
        }else{
            Message.error(res.msg)
        }
    }


    // 获取逾期清单列表
    const getOverdueList = async ()=>{
        let param = {
            // ...queryForm.formData
        }
        table.value.configs.loading = true

        let res = await FinancialApi.getInstance().getOverdueList(param)
        if(res.code == 0){
            res.data.forEach((item,index)=>{
                item.no = index + 1
                item.invoice_no = !item.invoice_no? '-' : item.invoice_no
                item.finance_remark = item.finance_remark == ''? '-' : item.finance_remark
                item.sales_name = item.sales_name == ''? '-' : item.sales_name
                // item.source = !item.source? '-' : sourceObj.value[item.source]
                item.pay_amount = formatMoney(item,'pay_amount','EUR'),
                item.invoice_timestamp = !item.invoice_timestamp? '-' : timestampToDate(item.invoice_timestamp * 1000).split(' ')[0],
                item.remarkIsText = true
            })
            table.value.datas = res.data
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    const formatMoney = (item,key, payCurrency)=>{
        return item[key] == undefined? '-' : 
                payCurrency == 'EUR'? '€ ' + Number(item[key]).toFixed(2) : Number(item[key]).toFixed(2)
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = 0 
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 80
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })


    onMounted(()=>{
        getOverdueList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })
</script>

<style lang="less" scoped>
/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: -10px 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}


/deep/ .table_pagination{
    display: none !important;
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

.remark_content{
    cursor: pointer;
}

.amountBlock{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 120px;
        }
    }
}
</style>